export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14363.58b7d699.jpg";